import { render, staticRenderFns } from "./GYSZhi.vue?vue&type=template&id=06b8215e&scoped=true&"
import script from "./GYSZhi.vue?vue&type=script&lang=js&"
export * from "./GYSZhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8215e",
  null
  
)

export default component.exports